import { createAsyncThunk } from "@reduxjs/toolkit";
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from "../../utils/api";
import { setAlert } from "../alerts/actions";

export const list = createAsyncThunk("permissions/list", async (params = { page: 0, limit: 10, orderBy: null, orderDirection: null, filter: null, search: null }) => {
    try {
        const page = params.page ? params.page : 0
        const limit = params.limit ? params.limit : 10
        const res = await api.get(`/admin/permissions`, { params });
        console.log(page, limit)
        return { ...res.data, page, limit };
    } catch (error) {
        console.log(error);
    }
});

export const create = createAsyncThunk("permissions/create", async ({ data, navigate }, { dispatch }) => {
    try {
        const res = await api.post('/admin/permissions', data);
        dispatch(list());
        dispatch(setAlert({ message: 'Permission Added successfully', alertType: 'success' }))
        if (navigate)
            navigate(`/cms/permissions`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const get = createAsyncThunk("permissions/get", async (id, { dispatch }) => {
    try {
        const res = await api.get(`/admin/permissions/${id}`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const edit = createAsyncThunk("permissions/edit", async ({ id, data, navigate }, { dispatch }) => {
    try {
        console.log(data);
        await api.put(`/admin/permissions/${id}`, data);
        dispatch(setAlert({ message: 'Permission updated successfully', alertType: 'success' }))
        dispatch(list());
        if (navigate)
            navigate(`/cms/permissions`);
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});


export const remove = createAsyncThunk("permissions/remove", async (id, { dispatch }) => {
    try {
        await api.delete(`/admin/permissions/${id}`);
        dispatch(setAlert({ message: 'Permission removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const bulk_remove = createAsyncThunk("permissions/bulk-remove", async ({ data }, { dispatch }) => {
    try {
        await api.post(`/admin/permissions/delete`, data);
        dispatch(setAlert({ message: 'Permissions removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});